export const MARKET_LOADING = "MARKET_LOADING";
export const MARKET_RESET = "MARKET_RESET";
export const GET_MARKET = "GET_MARKET";
export const GET_MARKET_SUCCESS = "GET_MARKET_SUCCESS";
export const GET_MARKET_FAIL = "GET_MARKET_FAIL";
export const DELETE_MARKET = "DELETE_MARKET";
export const DELETE_MARKET_SUCCESS = "DELETE_MARKET_SUCCESS";
export const DELETE_MARKET_FAIL = "DELETE_MARKET_FAIL";
export const UPDATE_MARKET = "UPDATE_MARKET";
export const UPDATE_MARKET_SUCCESS = "UPDATE_MARKET_SUCCESS";
export const UPDATE_MARKET_FAIL = "UPDATE_MARKET_FAIL";
export const ADD_NEW_MARKET = "ADD_NEW_MARKET";
export const ADD_MARKET_SUCCESS = "ADD_MARKET_SUCCESS";
export const ADD_MARKET_FAIL = "ADD_MARKET_FAIL";
